// Page title, cycle buttons (prev / current / next) and Reload.
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.

export default function PageHeader({ canWrite, customers, cycleKey, from, jumpCycle, jumpNext, jumpPrev, loading, refreshing, reload, to }) {
  return (
    <>
      <div className="page-head">
        <h1>Balances — reconciliation
          <span className="small"> · {from} → {to} · {customers.length} customers</span>
          {refreshing && (
            <span style={{ marginLeft: '0.75rem', fontSize: '0.6em', color: '#0369a1', fontWeight: 400, fontStyle: 'italic' }}>
              ↻ updating…
            </span>
          )}
        </h1>
        <div className="page-head-controls">
          <button className="refresh-btn" onClick={jumpPrev}>‹ Prev cycle</button>
          <button className="refresh-btn" onClick={jumpCycle}>Current cycle</button>
          <button className="refresh-btn" onClick={jumpNext}>Next cycle ›</button>
          {canWrite && (
          <button className="refresh-btn"
            onClick={() => window.open('/api/corrections-report?cycle_key=' + encodeURIComponent(cycleKey) + '&format=pdf', '_blank')}
            disabled={loading}
            title="PDF report of corrections made in this cycle, grouped by operator (driver)"
            style={{ background: '#0e7490' }}>
            📋 Corrections report
          </button>
          )}
          {canWrite && (
          <button className="refresh-btn" onClick={reload} disabled={loading}>{loading ? 'Loading…' : 'Reload'}</button>
          )}
        </div>
      </div>
    </>
  );
}
